import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import Layout from "@/components/Layout";
import { api } from "@/lib/apiClient";

export default function BlogPost() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [post, setPost] = useState(null);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => {
      setPost(r.data);
      document.title = r.data.title;
    }).catch(() => nav("/blog"));
  }, [slug, nav]);

  if (!post) return <Layout><div className="max-w-3xl mx-auto p-10 text-slate-500">Caricamento…</div></Layout>;

  return (
    <Layout>
      <article className="max-w-3xl mx-auto px-6 lg:px-10 py-14" data-testid="blog-article">
        <Link to="/blog" className="label-mono text-[#002FA7] text-sm hover:underline">← Tutti gli articoli</Link>
        <div className="label-mono text-xs bg-slate-100 text-slate-600 inline-block px-2 py-1 mt-6 mb-4">{post.categoria}</div>
        <div className="blog-prose">
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              h1: ({ node, ...p }) => <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tight mb-6 mt-2" {...p} />,
              h2: ({ node, ...p }) => <h2 className="font-display font-bold text-2xl mt-10 mb-4" {...p} />,
              h3: ({ node, ...p }) => <h3 className="font-display font-bold text-lg mt-8 mb-3" {...p} />,
              p: ({ node, ...p }) => <p className="text-[15px] leading-relaxed text-slate-700 mb-4" {...p} />,
              ul: ({ node, ...p }) => <ul className="list-disc pl-6 space-y-2 mb-4 text-[15px] text-slate-700" {...p} />,
              ol: ({ node, ...p }) => <ol className="list-decimal pl-6 space-y-2 mb-4 text-[15px] text-slate-700" {...p} />,
              li: ({ node, ...p }) => <li className="leading-relaxed" {...p} />,
              a: ({ node, ...p }) => <a className="text-[#002FA7] underline font-medium" {...p} />,
              strong: ({ node, ...p }) => <strong className="font-semibold text-[#0A0F1A]" {...p} />,
              em: ({ node, ...p }) => <em className="text-slate-600" {...p} />,
              hr: () => <hr className="my-10 border-slate-200" />,
              table: ({ node, ...p }) => <div className="overflow-x-auto mb-6"><table className="w-full text-sm border border-slate-300" {...p} /></div>,
              thead: ({ node, ...p }) => <thead className="bg-slate-100 label-mono" {...p} />,
              th: ({ node, ...p }) => <th className="text-left p-3 border border-slate-300" {...p} />,
              td: ({ node, ...p }) => <td className="p-3 border border-slate-200" {...p} />,
              blockquote: ({ node, ...p }) => <blockquote className="border-l-4 border-[#002FA7] bg-slate-50 pl-5 py-3 my-6 text-slate-700" {...p} />,
            }}
          >
            {post.body}
          </ReactMarkdown>
        </div>
      </article>
    </Layout>
  );
}
